@if (reviews?.length > 0) {
  <sd-component-wrapper [content]="content" [themesConfig]="reviewsConfig?.reviews?.backgroundTheme">
    <sd-show-more sd-component-wrapper-component
      [itemTemplate]="reviewTemplate"
      [showLessButton]="false"
      [size]="showMoreSize"
      [showSize]="showSize"
      [showedRow]="rowIndexInit"
      (more)="loadMore()"
      [items]="reviews"
      [totalCount]="pagination.totalElements"
      [dynamicContentShowMore]="dynamicContentShowMore"
    />
    <ng-template #reviewTemplate let-review>
      <sd-review icon="icon-account" [reviewContent]="review" [isSmall]="true" />
    </ng-template>
  </sd-component-wrapper>
}
